// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import { Icon } from "semantic-ui-react";
import * as i18n from "../../config/i18n";
import { ApplicationListItem } from "../ApplicationList";
import { ApplicationWindow } from "../ApplicationWindow";
import { highlighter } from "./utils/highlighter";
import { jsx as _jsx } from "react/jsx-runtime";
export const ApplicationSearchResult = props => {
  const {
    libelle,
    description,
    path,
    query
  } = props;
  const IconOpen = React.useMemo(() => /*#__PURE__*/_jsx(Icon, {
    name: "share square",
    link: true
  }), []);
  const OpenAction = React.useMemo(() => ({
    icon: IconOpen,
    title: i18n.navigationOpenTab
  }), [IconOpen]);
  const highlightChunks = highlighter(libelle, query);
  const content = React.useMemo(() => /*#__PURE__*/_jsx("span", {
    className: "highlight",
    children: highlightChunks.map(({
      chunk,
      highlighted
    }) => highlighted ? /*#__PURE__*/_jsx("mark", {
      children: chunk
    }, `mark-${chunk}`) : /*#__PURE__*/_jsx("span", {
      children: chunk
    }, `span-${chunk}`))
  }), [highlightChunks]);
  return React.useMemo(() => /*#__PURE__*/_jsx(ApplicationWindow, {
    path: path,
    children: ({
      onOpen
    }) => /*#__PURE__*/_jsx(ApplicationListItem, {
      content: content,
      description: description,
      path: path,
      actions: [{
        ...OpenAction,
        onClick: onOpen
      }],
      link: true
    })
  }), [OpenAction, description, content, path]);
};